import { computed } from '@ember/object';
import { capitalize } from '@ember/string';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  type: attr(String),
  name: computed('type', function () {
    return capitalize(this.type.toLowerCase());
  })
});